import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { ENV } from '@constants/constants';
// @ts-expect-error: Cypress not on window
const isTestEnv = typeof window !== 'undefined' && !!window?.Cypress;

export interface ITelemetryInitializer {
  userId?: number;
  customerNumber?: string | -1;
  isLoggedIn?: boolean;
  userName?: string;
}

// Setup a fake history object so ApplicationInsights starts
// NextJS extends window.history with extra routing data
const defaultHistory = {
  url: '/',
  location: { pathname: '' },
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  listen: () => {},
  state: {
    url: '/'
  }
};
let browserHistory = defaultHistory;
if (typeof window !== 'undefined') {
  browserHistory = { ...browserHistory, ...window.history };
  browserHistory.location.pathname = browserHistory?.state?.url;
}

const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
  config: {
    connectionString: ENV.NEXT_PUBLIC_APPLICATIONINSIGHTS_CONNECTION_STRING,
    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: { history: browserHistory }
    },
    enableAutoRouteTracking: true,
    enableCorsCorrelation: true,
    enableRequestHeaderTracking: true,
    enableResponseHeaderTracking: true,
    autoTrackPageVisitTime: true,
    enableUnhandledPromiseRejectionTracking: true,
    ...(isTestEnv
      ? {
          connectionString:
            'InstrumentationKey=00000000-0000-0000-0000-000000000000;IngestionEndpoint=https://TestIngestionEndpoint/;LiveEndpoint=https://TestLiveEndpoint/',
          disableInstrumentationKeyValidation: true,
          disableTelemetry: true
        }
      : {})
  }
});

export function createTelemetryInitializer({ userId, customerNumber, isLoggedIn, userName }: ITelemetryInitializer): AppCallbackFn {
  return function telemetryInitializer(envelope: any) {
    envelope.tags['ai.cloud.role'] = 'NextJS-ClientSide';
    customerNumber && (envelope.data.CustomerNumber = String(customerNumber ?? -1));
    isLoggedIn && (envelope.data.IsLoggedIn = isLoggedIn);
    userId && (envelope.data.UserId = String(userId ?? -1));
    userName && (envelope.data.userName = String(userName ?? ''));
    return true;
  };
}

export { reactPlugin, appInsights };
